import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, Mail, Phone, MapPin, Ribbon } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';
export function FinalCtaSection() {
  const {
    t
  } = useTranslation();
  return <section id="contact" className="py-24 bg-white relative" data-id="element-175">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-177">
          <h2 className="font-serif text-4xl md:text-5xl text-gray-900 mb-8" data-id="element-178">
            {t.finalCta.heading}
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-179">{t.finalCta.intro1}</p>
          <p className="text-lg text-gray-600 mb-12 max-w-3xl mx-auto" data-id="element-180">
            {t.finalCta.intro2}
          </p>
          <div className="py-8 px-4" data-id="element-181">
            <p className="font-script text-4xl md:text-5xl text-lavender-600 leading-relaxed" data-id="element-182">
              {t.finalCta.quote}
            </p>
          </div>
          <p className="font-serif text-xl text-gray-500 mt-8" data-id="element-183">
            {t.finalCta.tagline}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-cream-50 rounded-3xl p-8 md:p-12 border border-lavender-100 shadow-sm" data-id="element-184">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-sm mb-8" data-id="element-185">
            <Ribbon className="w-8 h-8 text-lavender-500" data-id="element-186" />
          </div>

          <h3 className="font-serif text-3xl text-gray-900 mb-10" data-id="element-187">
            {t.finalCta.cardsHeading}
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-188">
            <a href="#collection" className="bg-white p-6 rounded-2xl border border-lavender-100 hover:border-lavender-300 hover:shadow-md transition-all group text-left flex flex-col h-full" data-id="element-189">
              <div className="flex items-center gap-4 mb-4" data-id="element-190">
                <div className="w-12 h-12 bg-lavender-50 rounded-full flex items-center justify-center group-hover:bg-lavender-100 transition-colors" data-id="element-191">
                  <ShoppingBag className="w-6 h-6 text-lavender-600" data-id="element-192" />
                </div>
                <h4 className="font-serif text-xl font-semibold text-gray-900" data-id="element-193">
                  {t.finalCta.cards.shop.title}
                </h4>
              </div>
              <p className="text-gray-600 text-sm mt-auto" data-id="element-194">
                {t.finalCta.cards.shop.desc}
              </p>
            </a>

            <a href="mailto:ferbystore4@gmail.com" className="bg-white p-6 rounded-2xl border border-lavender-100 hover:border-lavender-300 hover:shadow-md transition-all group text-left flex flex-col h-full" data-id="element-195">
              <div className="flex items-center gap-4 mb-4" data-id="element-196">
                <div className="w-12 h-12 bg-blush-50 rounded-full flex items-center justify-center group-hover:bg-blush-100 transition-colors" data-id="element-197">
                  <Mail className="w-6 h-6 text-blush-600" data-id="element-198" />
                </div>
                <h4 className="font-serif text-xl font-semibold text-gray-900" data-id="element-199">
                  {t.finalCta.cards.custom.title}
                </h4>
              </div>
              <p className="text-gray-600 text-sm mt-auto" data-id="element-200">
                {t.finalCta.cards.custom.desc}
                <br data-id="element-201" />
                <span className="font-medium text-lavender-600 mt-2 block" data-id="element-202">
                  ferbystore4@gmail.com
                </span>
              </p>
            </a>

            <a href="tel:385-549-3420" className="bg-white p-6 rounded-2xl border border-lavender-100 hover:border-lavender-300 hover:shadow-md transition-all group text-left flex flex-col h-full" data-id="element-203">
              <div className="flex items-center gap-4 mb-4" data-id="element-204">
                <div className="w-12 h-12 bg-cream-100 rounded-full flex items-center justify-center group-hover:bg-cream-200 transition-colors" data-id="element-205">
                  <Phone className="w-6 h-6 text-gold-600" data-id="element-206" />
                </div>
                <h4 className="font-serif text-xl font-semibold text-gray-900" data-id="element-207">
                  {t.finalCta.cards.phone.title}
                </h4>
              </div>
              <p className="text-gray-600 text-sm mt-auto" data-id="element-208">
                {t.finalCta.cards.phone.desc}
                <br data-id="element-209" />
                <span className="font-medium text-lavender-600 mt-2 block" data-id="element-210">
                  385-549-3420
                </span>
              </p>
            </a>

            <div className="bg-white p-6 rounded-2xl border border-lavender-100 group text-left flex flex-col h-full" data-id="element-211">
              <div className="flex items-center gap-4 mb-4" data-id="element-212">
                <div className="w-12 h-12 bg-lavender-50 rounded-full flex items-center justify-center" data-id="element-213">
                  <MapPin className="w-6 h-6 text-lavender-600" data-id="element-214" />
                </div>
                <h4 className="font-serif text-xl font-semibold text-gray-900" data-id="element-215">
                  {t.finalCta.cards.visit.title}
                </h4>
              </div>
              <p className="text-gray-600 text-sm mt-auto" data-id="element-216">
                {t.finalCta.cards.visit.addr1}
                <br data-id="element-217" />
                {t.finalCta.cards.visit.addr2}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}